import React, { useEffect, useState, useContext, useCallback } from 'react';
import AuthContext from '../services/AuthContext';
import axiosInstance from '../services/axiosInstance';
import SurveyModal from './SurveyModal';

export default function SurveyCheck() {
    const { user } = useContext(AuthContext);
    const [pendingSurvey, setPendingSurvey] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const fetchPending = useCallback(async () => {
        if (!user) {
            console.log('SurveyCheck: No user, skipping');
            return;
        }
        if (user.role !== 'student') {
            console.log('SurveyCheck: User is not a student, skipping. Role:', user.role);
            return;
        }

        try {
            console.log('SurveyCheck: Fetching pending surveys...');
            const { data } = await axiosInstance.get('/surveys/check-pending');
            console.log('SurveyCheck: Pending results:', data);
            
            const surveys = data.pendingSurveys || [];
            
            if (surveys.length > 0) {
                console.log('SurveyCheck: Setting pending survey:', surveys[0]);
                setPendingSurvey(surveys[0]);
                setIsOpen(true);
            } else {
                console.log('SurveyCheck: No pending surveys found for this user.');
            }
        } catch (e) {
            console.error('SurveyCheck: Fetch error:', e);
        }
    }, [user]);

    useEffect(() => {
        // Initial check after a delay to ensure everything is loaded
        const timer = setTimeout(fetchPending, 3000);
        return () => clearTimeout(timer);
    }, [fetchPending]);

    const handleClose = () => {
        setIsOpen(false);
        // We'll let the next poll or next session trigger it again if it's mandatory
    };

    if (!pendingSurvey) return null;

    return (
        <SurveyModal 
            isOpen={isOpen} 
            onClose={handleClose} 
            surveyId={pendingSurvey._id} 
        />
    );
}
